module.exports = __webpack_public_path__ + "static/img/Rat.b2598b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/cz_animal/Rat.svg
// module id = 1366
// module chunks = 0